/**
 * JS (not JSON) so we can define loadLocaleFrom. Required for getT() during
 * getServerSideProps: the next-translate wrapper sets global.i18nConfig before
 * your loader runs; without loadLocaleFrom here, SSR footer/meta/breadcrumb get
 * empty namespaces (client hydrates later via __namespaces in props).
 */
module.exports = {
  // en disabled for launch (owner, 2026-09-09) — keep in sync with
  // next.config.ts i18n.locales; the en locale files stay in ./locales/en
  // untouched for the re-enable.
  locales: [
        "el",
    ],
  defaultLocale: "el",
  localeDetection: false,
  pages: {
    "*": [
      "forms",
      "main",
      "myphysiowave",
      "myphysiowave-custom",
    ],
  },
  loadLocaleFrom: (lang, ns) =>
    import(`./locales/${lang}/${ns}.json`).then((m) => m.default),
};
